import * as React from "react";
import type { SVGProps } from "react";
const SvgNotAllowed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 12c0 5.51 4.49 10 10 10s10-4.49 10-10S17.51 2 12 2 2 6.49 2 12m5.09-6.31A7.96 7.96 0 0 1 12 4c4.41 0 8 3.59 8 8a7.96 7.96 0 0 1-1.69 4.91zM5.68 7.1A7.96 7.96 0 0 0 4 12c0 4.41 3.59 8 8 8a7.96 7.96 0 0 0 4.9-1.68z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNotAllowed;
